export default __webpack_public_path__ + "static/media/close.7fb8e326.svg";